export const locationsData = [
    {
        "id": "56",
        "name": "ciudadsalud-1",
        "url": "ciudadsalud",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "coords": "279.6,230 309.9,235 303.9,274.9 272.8,269.1",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-2",
        "url": "ciudadsalud",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "coords": "309.9,235 340.6,240.1 332.8,280 303.9,274.9",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-3",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "340.6,240.1 370.3,245.5 363.6,285.7 332.8,280",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-4",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "370.3,245.5 397.8,250.3 393,290.8 363.6,285.7",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-5",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "397.8,250.3 430,255.7 424.3,295.7 393,290.8",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-6",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "430,255.7 460.1,261.1 452.5,300.7 424.3,295.7",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-7",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "460.1,261.1 488.9,266.3 482.7,305.6 452.5,300.7",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-8",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "488.9,266.3 519.5,271.7 512.4,311.4 482.7,305.6",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-9",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "519.5,271.7 549.8,276.4 542.6,316.8 512.4,311.4",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-10",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "559.7,278.7 589.5,284.2 578.2,346.6 548.5,341.6",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-11",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "589.5,284.2 619.9,288.9 608.6,352.2 578.2,346.6",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-12",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "619.9,288.9 649.7,294.2 637.9,358.3 608.6,352.2",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-13",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "649.7,294.2 679.3,299.9 667.8,363.2 637.9,358.3",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-14",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "679.3,299.9 709.3,304.9 698.3,368.7 667.8,363.2",
        "color": "31af67",
    },
    {
        "id": "56",
        "name": "ciudadsalud-15",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "709.3,304.9 740,310.9 728.4,374.6 698.3,368.7",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-16",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "740,310.9 769.6,316.1 757.8,380 728.4,374.6",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-17",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "769.6,316.1 799.3,321.5 787.9,384.8 757.8,380",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-18",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "799.3,321.5 829.3,326.5 818.2,390.5 787.9,384.8",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-19",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "829.3,326.5 859.5,332.1 847.5,396.3 818.2,390.5",
        "color": "B00000",
    },
    {
        "id": "56",
        "name": "ciudadsalud-20",
        "type": "VALLE SUR ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "859.5,332.1 919.2,342.6 907.5,406.6 847.5,396.3",
        "color": "31af67",
    },

    {
        "id": "57",
        "name": "ciudadsalud-21",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1195,295.6 1220.6,299.8 1211.3,353.9 1185.7,350.2",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-22",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1245.2,303.7 1264.1,306.9 1255.2,361.8 1236.1,358.6",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-23",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1220.6,299.8 1245.2,303.7 1236.1,358.6 1211.3,353.9 ",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-24",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1264.1,306.9 1282.6,310.1 1274.1,364.2 1255.2,361.8",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-25",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1282.6,310.1 1301.6,313.6 1292.8,367.4 1274.1,364.2",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-26",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1301.6,313.6 1320.1,316.6 1311.4,371.3 1292.8,367.4",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-27",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1320.1,316.6 1339.1,319.8 1330.2,374.6 1311.4,371.3",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-28",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1339.1,319.8 1357.9,323 1349.3,377.4 1330.2,374.6",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-29",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1357.9,323 1376,325.6 1367.8,380.6 1349.3,377.4 ",
        "color": "31af67",
    },
    {
        "id": "57",
        "name": "ciudadsalud-30",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1376,325.6 1395.1,328.9 1387.4,384 1367.8,380.6 ",
        "color": "B00000",
    },
    {
        "id": "57",
        "name": "ciudadsalud-31",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1395.1,328.9 1413.9,331.7 1405.9,387 1387.4,384 ",
        "color": "31af67",
    },
    {
        "id": "57",
        "name": "ciudadsalud-32",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1413.9,331.7 1433.1,335.6 1424,390.1 1405.9,387 ",
        "color": "31af67",
    },
    {
        "id": "57",
        "name": "ciudadsalud-33",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1433.1,335.6 1451.6,338.7 1442.7,392.7 1424,390.1",
        "color": "31af67",
    },
    {
        "id": "57",
        "name": "ciudadsalud-34",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1451.6,338.7 1470.5,341.6 1461.9,396.1 1442.7,392.7 ",
        "color": "31af67",
    },
    {
        "id": "57",
        "name": "ciudadsalud-35",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1470.5,341.6 1489.3,344.8 1479.8,399.6 1461.9,396.1 ",
        "color": "31af67",
    },
    {
        "id": "57",
        "name": "ciudadsalud-36",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1489.3,344.8 1507.8,347.8 1498.6,402.6 1479.8,399.6 ",
        "color": "31af67",
    },
    {
        "id": "57",
        "name": "ciudadsalud-37",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1507.8,347.8 1527.2,350.9 1516.9,406 1498.6,402.6 ",
        "color": "31af67",
    },
    {
        "id": "57",
        "name": "ciudadsalud-38",
        "type": "VALLE NORTE ZONA COMERCIAL",
        "position": "top",
        "shape": "poly",
        "url": "ciudadsalud",
        "coords": "1527.2,350.9 1548.3,354.8 1536.9,409.3 1516.9,406 ",
        "color": "31af67",
    },
]
